<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = false [showAssembly] = false [showRepseq]=true></app-gene-table-selector>
    <app-sample-rep-panel></app-sample-rep-panel>
</div>

